import { useQueryClient } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { onFirebaseMessage } from "./firebaseMessaging";
import { NotificationBadgeContext } from "./NotificationBadgeContext";

export default function ChatUpdater() {
  const queryClient = useQueryClient();

  // eslint-disable-next-line no-unused-vars
  const [_, setNotifications] = useContext(NotificationBadgeContext);

  useEffect(() => {
    // Listener para mensajes entrantes de FCM
    const unsubscribe = onFirebaseMessage((payload) => {
      // Si el mensaje tiene chatId, invalidar queries relacionados
      const chatId = payload?.data?.chatId;
      if (chatId) {
        // Invalidar las queries de chats y mensajes del chat específico
        queryClient.invalidateQueries({ queryKey: ["chats"] });
        queryClient.invalidateQueries({
          queryKey: ["chatMessages", Number(chatId)],
        });
        // Play notification sound
        try {
          const audio = new Audio("/notificacion.mp3");
          audio.play();
        } catch (error) {
          console.error(
            "Error al reproducir el sonido de notificación:",
            error
          );
        }
        // Add to notification badges
        setNotifications((prev) => {
          const newCount = (prev[chatId] || 0) + 1;
          localStorage.setItem(
            "notificationState",
            JSON.stringify({ ...prev, [chatId]: newCount })
          );
          return { ...prev, [chatId]: newCount };
        });
      }
    });
    return () => {
      // Limpia el listener si onFirebaseMessage devuelve una función de cleanup
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [queryClient, setNotifications]);

  return null;
}
